import React, { useMemo } from 'react';
import { Modal, ModalBody, Table } from 'reactstrap';
import modalclose from '../../../images/close1.png';
import './index.css';

const OrderSummaryModal = ({ isOpen, toggle, orderData }) => {
  const products = useMemo(() => orderData.order_product_data || [], [
    orderData,
  ]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered id="orderSummary">
      <ModalBody className="p-0">
        <div className="modalHeader mb-0">
          <div className="title">
            ORDER SUMMARY ({orderData.dealership_name || ''})
          </div>
          <div className="closeButton">
            <img src={modalclose} alt="close" onClick={toggle} />
          </div>
        </div>
        <div className="bodyArea">
          <Table responsive bordered>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Material Details</th>
                <th>No. of packages</th>
                <th>Total Quantity</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{product.name || '-'}</td>
                    <td>{product.qty || '-'}</td>
                    <td>{product.total_quantity || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OrderSummaryModal;
